import { render, staticRenderFns } from "./Result.vue?vue&type=template&id=82beabb0&scoped=true"
import script from "./Result.vue?vue&type=script&lang=js"
export * from "./Result.vue?vue&type=script&lang=js"
import style0 from "./Result.vue?vue&type=style&index=0&id=82beabb0&prod&lang=css"
import style1 from "./Result.vue?vue&type=style&index=1&id=82beabb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82beabb0",
  null
  
)

export default component.exports